"use client";

import {useEffect, useState} from "react";
import {createRepertoire, getWorks} from "@/lib/api";
import { useRouter } from "next/navigation";
import {RepertoireStatus, repertoireStatusLabel} from "@/types/enums";
import {RepertoireEntry} from "@/types/repertoire";
import {Work} from "@/types/work";

export function RepertoireForm() {
    const router = useRouter();

    const [works, setWorks] = useState<Work[]>([]);

    const [formData, setFormData] = useState<RepertoireEntry>({
        work_id: 0,
        status: RepertoireStatus.ADDED
    });

    useEffect(() => {
        getWorks().then(setWorks).catch(console.error);
    }, []);

    const handleChange = (
        e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
    ) => {
        const { name, value } = e.target;

        setFormData({
            ...formData,
            [name]:
                name === "work_id"
                    ? Number(value)
                    : value,
        });

    };

    async function handleSubmit(e: React.SyntheticEvent) {
        e.preventDefault();

        await createRepertoire(formData.work_id);

        router.push("/repertoire");
        router.refresh();
    }

    return (
        <form onSubmit={handleSubmit} className="space-y-4">
              <select
                className="w-full rounded-xl border p-3"
                name="work_id"
                value={formData.work_id}
                onChange={handleChange}
            >
                <option value={0}>Select piece</option>

                {works.map((work) => (
                    <option key={work.id} value={work.id}>
                        {work.title}
                    </option>
                ))}
            </select>

            <select
                className="w-full rounded-xl border p-3"
                name="status"
                value={formData.status}
                onChange={handleChange}
            >
                {Object.values(RepertoireStatus).map(stage => (
                    <option key={stage} value={stage}>
                        {repertoireStatusLabel[stage]}
                    </option>
                ))}
            </select>

            <button
                type="submit"
                className="rounded-xl border px-4 py-2"
            >
                Add Piece
            </button>
        </form>
    );
}